import React from "react"
import { Link } from "react-router-dom";

function Error404() {
	return(
		<div className="h-screen flex flex-col items-center justify-center">
			<h1 className="">Bummer, Brah! Page Not Found</h1>
			<Link to="/" className="">Back to home</Link>
		</div>
	)
}

export default Error404;